import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Typography, Paper, Box } from '@mui/material'
import QuestionContainer from './QuestionContainer'
import { questionsetAnswerSaved, questionsetValueLimitation, selectQuestionSetById } from '../../../reducers/survey_questionset'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { questionSaveModify, SaveAnswer, selectQuestionsInQuestionSet } from '../../../reducers/survey_question'
import {ValueLimitation_Root, ValueLimitation_LimitAnswer, ValueLimitation_Sum } from './ValidationFunctions'
import AdditionalSaveAnswerLogic  from './SaveAnswerOverride'
import { selectErrorMessagesByKeyName } from '../../../reducers/reference_errormessages'
/**
 * 
 
questions={quizState.Questions}
authtoken={currentUser.AuthToken}
responseguid={quizState.ResponseGuid}
startfromBeginning={quizState.StartFromBeginning}
uom={quizState.UnitOfMeasure}
validationMessages={ValidationMessages}
questionPrompts={QuestionPrompts}
updateQuestionTotal={updateQuestionTotal}
updateQuestionsAnswered={updateQuestionsAnswered}
setCurrentIndex={setCurrentIndex} 
completeSuccessful={completeSuccessful}/>
*/

const questionSetVariants = {
  offscreen: {
    scale: 0.9
  },
  onscreen: {
    scale: 1.2,
    transition: {
      duration: .4
    }
  }
};

const QuestionSetItem = (props) => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch()

  const QuestionSet = useSelector((state) => selectQuestionSetById(state, props.QuestionSet.QuestionSetId))

  const Questions = useSelector((state) => selectQuestionsInQuestionSet(state, props.QuestionSet.QuestionSetId))
  const QS_Total = useSelector((state)=>selectErrorMessagesByKeyName(state,'VAL QS TOTAL VALUE'))
  const QS_Between = useSelector((state)=>selectErrorMessagesByKeyName(state,'VAL QS SELECT BETWEEN'))
  const ErrorMess = {"VAL QS TOTAL VALUE":QS_Total,"VAL QS SELECT BETWEEN":QS_Between}
  const [localState, setLocalState] = useState(QuestionSet)

  const QuestionSetHasContent = QuestionSet.QuestionSetStandardContent && QuestionSet.QuestionSetStandardContent.length > 3
  //const QuestionSetVisibilityFlag = QuestionSet.QuestionSetVisibilityFlag === '1' ? true : false

  const flag = Questions.find(question => question.QuestionDisplayedFlag === "1") ? true : false
  const ValueLimitationPassed = QuestionSet.ValueLimitationPassed
  const ValueLimitationError = QuestionSet.ValueLimitationError
  const { ValueLimitationType, ValueLimitationPrecision, ValueLimitationMin, ValueLimitationMax } = QuestionSet

  
// convert to api
const SaveAnswerOverrideList =[
  'LIMIT YES ANSWER'
]
  const ValueLimitation = () => {
    const {ValueLimitationFlag, ValueLimitationErrorMessage} = ValueLimitation_Root('QUESTION SET', QuestionSet, Questions, ValueLimitationType, ValueLimitationMin, ValueLimitationMax,ErrorMess)

    dispatch(questionsetValueLimitation({ QuestionSetId: QuestionSet.QuestionSetId, ValueLimitationPassed: ValueLimitationFlag, ValueLimitationError: ValueLimitationErrorMessage }))

  }

  // useEffect(() => {
  //   setFlag(Questions.find(question => question.QuestionDisplayedFlag === "1") ? true : false)
  // }, [Questions])

  useEffect(() => {
    if (QuestionSet.WasChanged === true) {
      ValueLimitation()
    }
     }, [QuestionSet, ValueLimitationPassed, ValueLimitationError, Questions])

  const saveAnswerOverride = (aprops) => {
    const prop_values = {
      ... aprops
        , QuestionSet: QuestionSet
        , Questions: Questions
        , currentUser : currentUser
        , responseGuid: props.responseGuid
        , dispatch: dispatch
      }
    AdditionalSaveAnswerLogic(prop_values)
   
  }


  return (

    <Box
      pb={4}
      pt={4}
      display={flag ? 'block' : 'none'}
      m={flag ? 1 : -2}
      id={"QS_" + QuestionSet.QuestionSetId}

    >
      <motion.div
      >
        <motion.div className="card" variants={questionSetVariants}>
          <Paper p={1}>
            <Box
              sx={{
                border: ValueLimitationPassed === false ? 2 : 0,
                borderColor: ValueLimitationPassed === false ? '#E6323A' : '#00000000',
                borderRadius: "4px"
              }}
            >
              {QuestionSet.QuestionSetStandardContent !== ''
                && (
                  <Typography variant='h6' p={2}
                    sx={{ color: ValueLimitationPassed === false ? '#E6323A' : '#000000' }}
                  >{QuestionSet.QuestionSetStandardContent}</Typography>
                )
              }
              {
                ValueLimitationPassed === false && (
                  <Box pl={4}>
                    <Typography variant="caption" sx={{color:"#E6323A"}}>*{ValueLimitationError}</Typography>
                  </Box>
                )
              }
              <QuestionContainer
                QuestionSetId={QuestionSet.QuestionSetId}
                QuestionSetHasContent={!QuestionSetHasContent}
                SaveAnswerOverride={saveAnswerOverride}
                UseSaveAnswerOverride={SaveAnswerOverrideList.indexOf(ValueLimitationType)>=0 ? true : false}
                key={"QSQ_" + QuestionSet.QuestionSetId}
                id={"QSQ_" + QuestionSet.QuestionSetId}
                responseGuid={props.responseGuid}
                Sequence={QuestionSet.QuestionSetSequence}
              />
            </Box>
          </Paper>
        </motion.div>
      </motion.div>

    </Box>
  )

}

export default QuestionSetItem